import { ListPartnerLeadsResponseSchema } from './list-partner-leads.schema';
/**
 * List Partner Leads Endpoint Contract
 * Fetches the leads associated with the authenticated partner tenant.
 * Restricted to tenantType === 'partner' with a configured hubspotPartnerCompanyId.
 */ export const listPartnerLeadsContract = {
    method: 'GET',
    path: '/api/v2/partner/leads',
    description: 'Fetches the HubSpot leads assigned to the authenticated partner',
    responseSchema: ListPartnerLeadsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - tenant is not a partner or has no hubspotPartnerCompanyId',
            502: 'Bad Gateway - HubSpot API request failed'
        }
    }
};

//# sourceMappingURL=list-partner-leads.contract.js.map